const menusAll =
    [
        {
            title: '订阅服务',
        },
        {
            title: '我的卡片',
            path: 'card',
            icon: require('@/assets/card/u_10.png'),
            icon_selected: require('@/assets/card/u_10_1.png'),
            width: 20,
            height: 20,
            key: 'card',
        },
        {
            title: '常见问题',
        },
        {
            title: '常见问题',
            path: 'service',
            icon: require('@/assets/card/ques_1.png'),
            icon_selected: require('@/assets/card/ques_1.png'),
            width: 30,
            height: 30,
            key: 'service',
        },
        {
            title: '隐私协议',
            path: 'privacyPolicy',
            icon: require('@/assets/ys.png'),
            icon_selected: require('@/assets/ys.png'),
            width: 30,
            height: 20,
            key: 'privacyPolicy',
        },
    ]

export default menusAll
